// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// import firebaseConfig from '../../firebase.json'; // TODO: Tim: setup firebase config for multiple environments

export const environment = {
  production: false,
  // Todo: Tim: these are non-prod firebase configs for MGX UI. Per Google/firebase documentation, these configs are not secret, and are intended to be used on the client side.
  firebase: {
    "apiKey": "AIzaSyCrIW6w3geEYCeDGon27E7d3pDvlYUJHn0",
    "authDomain": "mgi-mgx-nonprod.firebaseapp.com",
    "projectId": "mgi-mgx-nonprod",
    "storageBucket": "mgi-mgx-nonprod.firebasestorage.app",
    "messagingSenderId": "850327975860",
    "appId": "1:850327975860:web:7a2edb4f0787af8a14a4e1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
